import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 催促メール定型文取得処理
 *
 * @export GetRemindMailTempService
 * @class GetRemindMailTempService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetRemindMailTempService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetRemindMailTempService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetRemindMailTempService
   */
  execute(successFunc: Function): void {
    this.successFunc = successFunc;
    this.send('getRemindMailTemp', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetRemindMailTempService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data.RemindMailTempList);
    }
  }
}
